module.exports = __webpack_public_path__ + "static/media/recognition-slow.e81f7407.mp3";